import { render, staticRenderFns } from "./WarningNoData.vue?vue&type=template&id=67028288&scoped=true&"
import script from "./WarningNoData.vue?vue&type=script&lang=js&"
export * from "./WarningNoData.vue?vue&type=script&lang=js&"
import style0 from "./WarningNoData.vue?vue&type=style&index=0&id=67028288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67028288",
  null
  
)

export default component.exports